import React from 'react'

import { IconProps } from '../Types'

export const StarOutline = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="StarOutline"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path fill-rule="evenodd" d="m12.02,4.31l-2.01,4.22c-.12.27-.3.5-.53.68-.23.18-.5.29-.79.32l-4.47.69,3.24,3.24c.21.2.36.45.45.73.09.28.11.58.06.87h0s-.78,4.73-.78,4.73l4.03-2.21s.02,0,.03-.01c.25-.13.52-.19.79-.19s.55.07.79.19c0,0,.02,0,.03.01l4.02,2.21-.78-4.66h0c-.05-.29-.03-.59.06-.87.09-.28.24-.52.44-.72l3.21-3.31-4.45-.68c-.28-.04-.56-.15-.79-.32-.23-.18-.41-.41-.53-.68l-2.01-4.22Zm4.91,15.92h0s0,0,0,0ZM11.09,2.28c.28-.18.6-.28.93-.28s.65.1.93.28c.27.18.49.44.63.74l2.16,4.53,4.77.73c.32.05.62.18.87.4.25.22.44.5.54.83.1.32.11.67.03,1-.08.32-.25.62-.48.85l-3.44,3.55.83,4.98c.06.33.02.68-.1.99-.12.31-.33.58-.59.78s-.58.32-.9.34c-.32.02-.65-.05-.94-.21h0s-4.3-2.36-4.3-2.36l-4.3,2.36h0c-.29.16-.61.23-.94.21-.32-.02-.64-.14-.9-.34s-.47-.47-.59-.78c-.12-.31-.16-.65-.1-.99h0s.83-5.04.83-5.04l-3.48-3.49c-.24-.24-.41-.54-.49-.88-.08-.34-.06-.69.05-1.02.11-.33.31-.61.58-.82.25-.2.56-.33.88-.36l4.75-.73,2.16-4.53c.14-.3.36-.56.63-.74Z"/>',
    }}
  />
)

StarOutline.displayName = 'StarOutline'

export const tags = ['StarOutline', '']
